// The game strip's layout (2026-10-10): the row spans the full width of the
// dashboard below it, so its tiles share that width evenly, as many whole
// tiles as fit at their narrowest; and its ‹ › overlay the row's ends,
// shown only where there is more to scroll to. Pure: the component measures,
// this decides.

/** The narrowest a tile may be, in rem (its date, result and stage on one line each). */
export const TILE_MIN_REM = 5.75;

/** How many whole tiles fit side by side in `width`, each at least `tileMin` wide with `gap` between them; at least one. */
export function stripColumns(width: number, tileMin: number, gap: number): number {
  if (!(width > 0) || !(tileMin > 0)) return 1;
  return Math.max(1, Math.floor((width + Math.max(0, gap)) / (tileMin + Math.max(0, gap))));
}

/** Whether the row can scroll further back (towards the newer games, left) and forward (the older, right); a pixel of rounding is no scroll. */
export function scrollEdges(scrollLeft: number, clientWidth: number, scrollWidth: number): { back: boolean; forward: boolean } {
  return { back: scrollLeft > 1, forward: scrollLeft + clientWidth < scrollWidth - 1 };
}

/** How far one page moves the row: the visible tiles and the gap after the last, so the next page starts on a tile's edge. */
export function pageDistance(clientWidth: number, gap: number): number {
  return clientWidth + Math.max(0, gap);
}
